<template>
    <div class="sk-folding-cube" :style="{ width: size , height: size }">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
    </div>
</template>

<style lang="stylus">
    .sk-folding-cube
        position relative
        background #D9F8F8
        background-size 100% 100%

        .sk-cube
            float left
            width 50%
            height 50%
            position relative

            &:before
                content ""
                position absolute
                top 0
                left 0
                width 100%
                height 100%
                animation sk-foldCubeAngle 2.4s infinite linear both
                transform-origin 100% 100%
                background-color #00d1d2


        .sk-cube2
            -webkit-transform rotateZ(90deg)
            transform rotateZ(90deg)

            &:before
                -webkit-animation-delay 0.3s
                animation-delay 0.3s

        .sk-cube3
            -webkit-transform rotateZ(180deg)
            transform rotateZ(180deg)

            &:before
                -webkit-animation-delay 0.6s
                animation-delay 0.6s

        .sk-cube4
            -webkit-transform rotateZ(270deg)
            transform rotateZ(270deg)

            &:before
                -webkit-animation-delay 0.9s
                animation-delay 0.9s

    @keyframes sk-foldCubeAngle
        0%, 10%
            transform perspective(140px) rotateX(-180deg)
            opacity 0

        25%, 75%
            transform perspective(140px) rotateX(0deg)
            opacity 1

        90%, 100%
            transform perspective(140px) rotateY(180deg)
            opacity 0
</style>

<script>
    export default {
        name: 'spinner-iqos',

        props: {
            size: {
                type: [Number, String],
                default: '1rem'
            },
            color: {
                type: String
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/spinner/Spinner-Iqos.vue